import { getIntlLocale } from "@/i18n/translate";
import type { StationProduct } from "./api";

/** how many pizzas "Most used" offers */
export const MOST_USED_COUNT = 8;

const MINI = /^mini\s+/i;
const PIZZA = /^pizza\s+/i;

export interface PizzaLabel {
  title: string;
  mini: boolean;
}

/**
 * The tile's name without the words every tile would repeat: "MINI Pizza Hawaii" -> "Hawaii" with
 * the MINI badge, "Pizza šunka a žampiony" -> "Šunka a žampiony", "Šunková pizza" stays.
 */
export function pizzaLabel(name: string): PizzaLabel {
  let title = name.trim();
  const mini = MINI.test(title);
  if (mini) title = title.replace(MINI, "");
  if (PIZZA.test(title) && title.replace(PIZZA, "").trim()) title = title.replace(PIZZA, "");
  return { title: title.charAt(0).toLocaleUpperCase() + title.slice(1), mini };
}

export const normalize = (text: string) => text.trim().toLowerCase().normalize("NFD").replace(/\p{Mn}/gu, "");

/** the search finds a pizza by its name or by one of its distinctive ingredients ("ananas") */
export const matches = (product: StationProduct, query: string) =>
  [product.name, ...product.ingredients].some((text) => normalize(text).includes(query));

export function byTitle(products: StationProduct[]): StationProduct[] {
  const collator = new Intl.Collator(getIntlLocale());
  return [...products].sort((a, b) => collator.compare(pizzaLabel(a.name).title, pizzaLabel(b.name).title));
}

/** the branch's most photographed pizzas of the last 30 days, the most used first */
export function mostUsed(products: StationProduct[]): StationProduct[] {
  return byTitle(products.filter((p) => p.uses > 0))
    .sort((a, b) => b.uses - a.uses)
    .slice(0, MOST_USED_COUNT);
}
